import { render, staticRenderFns } from "./c_classify.vue?vue&type=template&id=c055dd5e&scoped=true"
import script from "./c_classify.vue?vue&type=script&lang=js"
export * from "./c_classify.vue?vue&type=script&lang=js"
import style0 from "./c_classify.vue?vue&type=style&index=0&id=c055dd5e&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c055dd5e",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/qingchi/workspace/mimi/mer_mer_admin/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('c055dd5e')) {
      api.createRecord('c055dd5e', component.options)
    } else {
      api.reload('c055dd5e', component.options)
    }
    module.hot.accept("./c_classify.vue?vue&type=template&id=c055dd5e&scoped=true", function () {
      api.rerender('c055dd5e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/PageDiy/mobileConfigRight/c_classify.vue"
export default component.exports